import { render, staticRenderFns } from "./PurchasesOrderViewAddDeliveryForm.vue?vue&type=template&id=2133b849&scoped=true"
import script from "./PurchasesOrderViewAddDeliveryForm.vue?vue&type=script&lang=js"
export * from "./PurchasesOrderViewAddDeliveryForm.vue?vue&type=script&lang=js"
import style0 from "./PurchasesOrderViewAddDeliveryForm.vue?vue&type=style&index=0&id=2133b849&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2133b849",
  null
  
)

export default component.exports